import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          主题索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          糖心视频、妖精视频、桃花视频等主题内容快速导航
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href={`#index`}
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 border border-background-200/70 rounded-xl cursor-pointer transition-all duration-300 hover:border-primary-200/60 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors text-center whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-400">{item.count}篇内容</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}